export default {
  root: '/',
  resetPassword: '/registration/create-password',
  forgotPassword: '/registration/forgot-password',
  login: '/login',

  notifications: '/notifications',
  menu: '/menu',

  lobby: '/lobby',

  networking: '/networking-lounge',

  auditorium1: '/auditorium-hall',

  exhibition1: '/exhibition-hall/1',
  exhibition2: '/exhibition-hall/2',
  exhibition3: '/exhibition-hall/3',

  lucky: '/lucky-draw',

  onDemand: '/gallery',
  onDemandOral: '/gallery/oral-presentations',
  onDemandPoster: '/gallery/e-poster-presentations',
  onDemandBbs: '/gallery/best-basic-science-award',
}
